module.exports = __webpack_public_path__ + "img/AddReactionOutlined.ed84e82a.svg";